
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.433 3.582V2.02c.21-.236.463-.418.761-.548.298-.133.596-.202.895-.206.333-.005.611.042.834.14.227.098.485.218.774.36.263.138.497.252.701.34.21.09.47.134.781.134.294 0 .581-.078.862-.233.28-.156.527-.372.74-.648v1.575a2.323 2.323 0 01-.734.548c-.28.133-.567.2-.86.2-.317 0-.584-.044-.802-.133a11.606 11.606 0 01-.728-.354c-.28-.138-.532-.254-.754-.347-.218-.094-.49-.14-.814-.14-.299 0-.597.077-.895.233a2.19 2.19 0 00-.761.641zm0 3V5.02c.21-.236.463-.418.761-.547a2.24 2.24 0 01.895-.207c.333-.005.611.042.834.14.227.098.485.218.774.36.263.138.497.252.701.34.21.09.47.134.781.134.294 0 .581-.078.862-.233.28-.156.527-.372.74-.648v1.575a2.323 2.323 0 01-.734.548c-.28.133-.567.2-.86.2-.317 0-.584-.044-.802-.133a11.606 11.606 0 01-.728-.354c-.28-.138-.532-.254-.754-.347-.218-.094-.49-.14-.814-.14-.299 0-.597.077-.895.233a2.19 2.19 0 00-.761.641z","fill":"#A09A9A"}})])
          )
        }
      }
    